import FinancialAssetContainer from '../financial-asset/FinancialAssetContainer';
import { Col, Row, Tabs } from 'antd';
import ProfileDetailContainer from './ProfileDetailContainer';
import { RouteComponentProps } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';
import MyExpenseListContainer from '../expenses/MyExpenseListContainer';

const { TabPane } = Tabs;

interface ProfileContainerProps {
  enterpriseId: string;
}

function ProfileContainer({
  history,
  match,
  ...rest
}: RouteComponentProps<ProfileContainerProps>) {
  const { enterpriseId } = match.params;
  return (
    <>
      <Row>
        <Col>
          <Title level={4}>내 계정</Title>
        </Col>
      </Row>
      <Tabs destroyInactiveTabPane>
        <TabPane tab="기본정보" key="1">
          <ProfileDetailContainer history={history} match={match} {...rest} />
        </TabPane>
        <TabPane tab="내 카드" key="2">
          <FinancialAssetContainer
            enterpriseId={enterpriseId}
            isMyAsset={true}
          />
        </TabPane>
        <TabPane tab="내 지출" key="3">
          <MyExpenseListContainer enterpriseId={enterpriseId} />
        </TabPane>
      </Tabs>
    </>
  );
}

export default ProfileContainer;
